import axios from '@/utils/axios'
import { AxiosPromise } from 'axios'

export const index = (params = {}): AxiosPromise => {
  return axios.get('/drafts', { params })
}

export const publish = (params = {}): AxiosPromise => {
  return axios.post('/drafts/publish', params)
}
